import parseHumanFloat from '~/utils/Number/parseHumanFloat';

import isValidPackageSize from './isValidPackageSize';

export default function parsePackageSize(packageSize: string | null): {
	value: number | null;
	isValid: boolean | null;
} {
	if (packageSize === '' || packageSize === null || packageSize === undefined) {
		return { value: null, isValid: null };
	}
	const value = parseHumanFloat(packageSize);
	const isValid = value !== null && isValidPackageSize(value);
	return { value: isValid ? value : null, isValid };
}
